import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { ChevronDown } from 'lucide-react'
import { cn } from '../../utils/cn'
import { PageHero, Section } from './_shared'

const FAQS = [
  {
    q: 'Is serenDPT investment advice?',
    a: 'No. serenDPT is a personal portfolio and research tool. Its scores, signals and rebalancing suggestions are informational only and are not recommendations to buy or sell any security. You are responsible for your own decisions.',
  },
  {
    q: 'Does it place real trades?',
    a: 'Order placement, where enabled, routes through your own connected Zerodha (Kite Connect) account — you stay in control. AngelOne is used read-only for live price ticks. A separate paper-trading engine lets you test strategies with no real capital.',
  },
  {
    q: 'Which brokers and data sources does it use?',
    a: 'Holdings and orders via Zerodha Kite Connect; live ticks via AngelOne SmartStream or the Kite Ticker. Mutual-fund NAVs come from public AMFI / MFAPI data. Optional integrations include OpenAI, Google News, Telegram and email for specific features.',
  },
  {
    q: 'Where is my data stored?',
    a: 'Portfolio and account data live in your own database. Knowledge-workspace notes and attachments are written to disk on your own server — there is no third-party notes database. Your information is never sold, profiled for ads, or shared with marketers.',
  },
  {
    q: 'Is my workspace data safe if something crashes?',
    a: 'Notes are written atomically with a shadow backup and self-heal on corruption, and every save is versioned with conflict detection. The app never reports “saved” unless the write actually succeeded.',
  },
  {
    q: 'Is there a free plan / sign-up?',
    a: 'serenDPT is a personal platform rather than a commercial service with tiers. It runs on your own deployment and connects to your own broker accounts.',
  },
  {
    q: 'How accurate are the numbers?',
    a: 'Accuracy is the first principle: if a value can’t be computed reliably, the platform hides it rather than showing an estimate. Live figures are only as current as the most recent verified tick.',
  },
]

function Item({ q, a, open, onToggle }) {
  return (
    <div className="card !p-0 overflow-hidden">
      <button onClick={onToggle} className="w-full flex items-center justify-between gap-4 text-left px-5 py-4 hover:bg-ink-25/60 transition-colors">
        <span className="font-semibold text-ink-900">{q}</span>
        <ChevronDown className={cn('w-4 h-4 text-ink-400 shrink-0 transition-transform', open && 'rotate-180')} />
      </button>
      {open && <div className="px-5 pb-5 -mt-1 text-[15px] leading-7 text-ink-600">{a}</div>}
    </div>
  )
}

export default function FAQ() {
  const [open, setOpen] = useState(0)
  return (
    <>
      <PageHero
        kicker="FAQ"
        title="Straight answers."
        lede="The questions worth asking before you trust any tool with your portfolio."
      />
      <Section>
        <div className="max-w-3xl space-y-3">
          {FAQS.map((f, i) => (
            <Item key={i} {...f} open={open === i} onToggle={() => setOpen(open === i ? -1 : i)} />
          ))}
        </div>
        <p className="mt-8 text-sm text-ink-500 max-w-3xl">
          Still curious? <Link to="/contact" className="text-accent-700 font-medium hover:text-accent-800">Send a question</Link> — happy to help.
        </p>
      </Section>
    </>
  )
}
